import { Switch } from "react-router-dom";
import AuthRoute from "ui/components/AuthRoute";
import CriarEditarClientes from "./Detalhes";
import Listagem from "./Listagem";
import { PermissaoEnum } from "core/resources/enums/permissao";

function ClientesPages() {
  return (
    <Switch>
      <AuthRoute
        path="/clientes"
        exact
        component={Listagem}
        permissions={[PermissaoEnum.Backoffice.Admin.Clientes.Visualizar]}
      />
      <AuthRoute
        path="/clientes/criar"
        exact
        component={CriarEditarClientes}
        permissions={[PermissaoEnum.Backoffice.Admin.Clientes.Criar]}
      />
      <AuthRoute
        path="/clientes/:id"
        exact
        component={CriarEditarClientes}
        permissions={[PermissaoEnum.Backoffice.Admin.Clientes.Editar]}
      />
    </Switch>
  );
}

export default ClientesPages;
